exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iconColor[data-v-ed81603e] {\n  color: #000000a6;\n}\n.word[data-v-ed81603e] {\n  color: #00a2ed;\n}\n.emailDocument[data-v-ed81603e] {\n  color: #0072C6;\n}\n.outlook[data-v-ed81603e] {\n  color: #0072C6;\n}\n.excel[data-v-ed81603e] {\n  color: #1D6F42;\n}\n.pdf[data-v-ed81603e] {\n  color: #F40F02;\n}\n.email[data-v-ed81603e] {\n  color: #0072C6;\n}\n.filter-container[data-v-ed81603e] {\n  display: flex;\n  gap: 1em;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: flex-start;\n}\n", ""]);

// exports
